import type { ComponentType } from 'react'
import { User, Table, Swords, CalendarClock } from 'lucide-react'
import ScorelineIcon from './icons/ScorelineIcon'

export type Tab = 'home' | 'pl' | 'predict' | 'leagues' | 'fixtures'

/** Widened from `LucideIcon` so a hand-written glyph (ScorelineIcon) is
 * assignable too — every lucide icon still satisfies it. Only the props the
 * nav call sites actually pass are declared. */
export type NavTabIcon = ComponentType<{
  className?: string
  'aria-hidden'?: boolean | 'true' | 'false'
}>

export interface NavTabMeta {
  id: Tab
  label: string
  icon: NavTabIcon
}

export const tabs: NavTabMeta[] = [
  { id: 'home', label: 'Home', icon: User },
  { id: 'leagues', label: 'Leagues', icon: Swords },
  { id: 'predict', label: 'Predict', icon: ScorelineIcon },
  { id: 'fixtures', label: 'Fixtures', icon: CalendarClock },
  { id: 'pl', label: 'PL', icon: Table },
]

/** Nav tab order, shared with swipe navigation so the two stay in sync. */
export const tabOrder: Tab[] = tabs.map((tab) => tab.id)
